import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AccordionModule } from 'primeng/accordion';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxEditorModule } from 'ngx-editor';
import { DropDownListAllModule, MultiSelectModule, AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { TagInputModule } from 'ngx-chips';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { NgxPaginationModule } from 'ngx-pagination';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InlineSVGModule } from 'ng-inline-svg';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ScheduleAllModule, RecurrenceEditorAllModule } from '@syncfusion/ej2-angular-schedule';
import { Select2Module } from 'ng2-select2';
import { ImageCropperModule } from 'ngx-image-cropper';
// import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [
    DatePickerModule,
    ScheduleAllModule,
    AccordionModule,
    CKEditorModule,
    TooltipModule,
    NgxEditorModule,
    MultiSelectModule,
    NumericTextBoxModule,
    TagInputModule,
    DropzoneModule,
    NgxPaginationModule,
    PdfViewerModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    NgxMaskModule,
    RecurrenceEditorAllModule,
    DropDownListAllModule,
    AutoCompleteModule,
    Select2Module,
    ImageCropperModule,
    TimePickerModule,
  ]
})
export class BuiltInModule {}



// WEBPACK FOOTER //
// ./src/app/shared/built-in/built-in.module.ts